//import React from 'react';

const AboutUs = () => {
  return <h2>Welcome to Prime Apps LLC! We deliver quality software solutions tailored to your business.</h2>;
};

export default AboutUs;